import { Grid } from '@kerfjs/ui/grid';
import type { SafeHtml } from 'kerfjs';

import { KPI_TILE_MIN_WIDTH, KpiTile } from '../../../components/kpi-tile.js';
import type { OrgSavingsT } from '../../../data/api.js';
import { formatPercentText } from '../../../lib/currency-format.js';

/** Four KPIs use every available column, then wrap at the tile minimum. */
export function SavingsKpiGrid({ savings: s }: { savings: OrgSavingsT }): SafeHtml {
  const savingsRatio = s.totalBestQuotes > 0 ? s.totalSavingsVsQuote / s.totalBestQuotes : null;
  return (
    <Grid minColumnWidth={KPI_TILE_MIN_WIDTH} gap={{ column: 'none', row: 's' }} className="savings-kpi-grid kpis">
      <KpiTile
        amount={s.totalSavingsVsQuote}
        currency={s.base}
        label={`${s.base} estimated savings · ${String(s.closedDemands)} closed demand${s.closedDemands === 1 ? '' : 's'}`}
      />
      <KpiTile
        value={savingsRatio === null ? '—' : formatPercentText(savingsRatio, { maximumFractionDigits: 1 })}
        label="of best original quotes"
      />
      <KpiTile
        value={`${String(s.linesImported)} · ${String(s.linesNegotiated)}`}
        label="Lines imported · negotiated"
      />
      <KpiTile
        amount={s.flaggedAwaitingOutcomes}
        currency={s.base}
        label={`${s.base} flagged, awaiting outcomes (${String(s.flaggedDemandCount)} demand${s.flaggedDemandCount === 1 ? '' : 's'})`}
      />
    </Grid>
  );
}
